import { z } from 'zod'

export interface IngredientSuggestion {
  id: string | null
  name: string
  canonicalUnit: string
}

export const recipeIngredientSchema = z.object({
  ingredientId: z.string().nullable(),
  ingredientName: z.string().min(1, 'Ingredient name is required'),
  canonicalUnit: z.string().min(1, 'Unit is required'),
  quantity: z.coerce.number().positive('Quantity must be greater than 0'),
  unit: z.string().min(1, 'Unit is required'),
})

export type RecipeIngredientFormData = z.infer<typeof recipeIngredientSchema>

export const recipeSchema = z.object({
  name: z.string().min(1).max(200),
  servingSize: z.coerce.number().int().min(1).max(50),
  ingredients: z.array(recipeIngredientSchema).min(1, 'At least one ingredient is required'),
  method: z.string().nullable().optional(),
})

export type RecipeFormData = z.infer<typeof recipeSchema>

export interface Recipe {
  id: string
  name: string
  servingSize: number
  method: string | null
  isFavourite: boolean
  createdAt: string
}

export interface RecipeIngredient {
  id: string
  ingredientId: string
  ingredientName: string
  quantity: number
  unit: string
  canonicalUnit: string
}

export interface RecipeDetail extends Recipe {
  ingredients: RecipeIngredient[]
}
